import { useEffect, useState } from 'react';

/** Same breakpoint as the layout's sidebar (LayoutPage) and the header rules in global.css. */
export const PHONE_QUERY = '(max-width: 768px)';

const read = (): boolean => (typeof window !== 'undefined' && typeof window.matchMedia === 'function' ? window.matchMedia(PHONE_QUERY).matches : false);

/** True while the viewport is a phone (or narrower than a tablet in portrait); follows resizes and rotation. */
export const useIsPhone = (): boolean => {
  const [phone, setPhone] = useState(read);
  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    const mq = window.matchMedia(PHONE_QUERY);
    const onChange = () => setPhone(mq.matches);
    onChange();
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);
  return phone;
};
